/* @ngInject */
const sterileIcons = () => {
  const self = {}

  self.name = 'train'
  self.weight = 'train'

  return self
}
export default sterileIcons



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/sterile/resources/icons.resource.js